import { Box, Container, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
//import { PageAssociatedPlansEndless } from '../../shared/components/layout/pagesAssociatedPlansEndless';
//import { PlansBenefits } from './components/PlansBenefits';
//import { NewsAttached } from './components/NewsAttached';
import { PlansSection } from './components/PlansSection';
import { ExtraBennefitsMobile } from './components/ExtraBennefitsMobile';
import { ContactUsMobile } from './components/ContactUsMobile';
//import { TipsSection } from './components/TipsSection';
import { ScrollDeph } from './components/ScrollDeph';
import { useOnScreen } from '../../shared/useOnScreen';
import { useAuth } from '../auth/auth-hook';
import { userCanUpdateSub } from '../../shared/utils';
import { useNavigate } from 'react-router-dom';
import { openDialogAlert } from '../alert/alert-actions';
import { AfterTipCancel } from './components/AfterTipCancel';
//import { ButtonWPP } from './components/ButtonWpp';
import { StripeButtonWithoutStoreTipsBanner } from '../stripe/StripeWithoutStoreTipsBanner';
import { TIPS_PRICE_ID } from '../../shared/constans';
import { ButtonWPPNew } from './components/ButtonWppNew';
const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    banner: {
      backgroundImage: 'url("/portada_landing.gif")',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      margin: '0 auto',
    },
    title: {
      fontSize: '35px !important',
      lineHeight: '42px !important',
      fontWeight: 'bold !important',
      textAlign: 'center',
      [theme.breakpoints.down('md')]: {
        fontSize: '20px !important',
        fontWeight: 'bold !important',
        lineHeight: '24px !important',
      },
    },
    subTitle: {
      fontSize: '30px !important',
      lineHeight: '30px !important',
      textAlign: 'center',
      color: '#000000',
      margin: '0 auto !important',
      [theme.breakpoints.down('md')]: {
        fontSize: '18px !important',
        lineHeight: '18px !important',
      },
    },
    subTitleOne: {
      fontSize: '24px !important',
      lineHeight: '30px !important',
      textAlign: 'center',
      color: '#000000',
      //margin: '0 auto !important',
      marginTop: '10px !important',
      [theme.breakpoints.down('md')]: {
        fontSize: '16px !important',
        lineHeight: '16px !important',
      },
    },
    subTitleTwo: {
      fontSize: '16px !important',
      lineHeight: '22px !important',
      textAlign: 'center',
      color: '#606060',
      opacity: '60%',
      //margin: '0 auto !important',
      marginTop: '15px !important',
      [theme.breakpoints.down('md')]: {
        fontSize: '12px !important',
        lineHeight: '12px !important',
      },
    },
    subTitleThree: {
      fontSize: '60px !important',
      lineHeight: '66px !important',
      textAlign: 'center',
      fontWeight: 'bold !important',
      //margin: '0 auto !important',
      marginTop: '15px !important',
      [theme.breakpoints.down('md')]: {
        fontSize: '30px !important',
        lineHeight: '33px !important',
        marginTop: '50px !important',
      },
    },
    subTitleFour: {
      fontSize: '50px !important',
      lineHeight: '55px !important',
      textAlign: 'center',
      fontStyle: 'italic',
      //margin: '0 auto !important',
      [theme.breakpoints.down('md')]: {
        fontSize: '30px !important',
        lineHeight: '33px !important',
      },
    },
  }),
);
export const AnotherNewPlansPage: React.FC = () => {
  const classes = useStyles();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [ref, isVisible] = useOnScreen<HTMLDivElement>({
    threshold: 0.1, // % visible para activar
  });
  if (user?.subscriptions?.length) {
    if (!userCanUpdateSub(user?.subscriptions?.[0])) {
      openDialogAlert(
        <>
          Tienes una suscripción activa o aún no ha llegado a su fecha de
          vencimiento.
          <br />
          Por favor,{' '}
          <a href="https://wa.me/525610190580" target="_blank">
            comunícate con un administrador
          </a>{' '}
          para actualizar tu plan.
        </>,
        () => {
          navigate('/');
        },
      );
    }
  }
  return (
    <div>
      <ButtonWPPNew />
      <AfterTipCancel />
      {/**
       * <Box component={'div'} style={{ backgroundColor: '#f5f7f9' }}>
        <Box
          height={{ xs: '400px', lg: '600px' }}
          width={'100%'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Box
            component={'img'}
            width={'600px'}
            height={'250px'}
            display={{ xs: 'none', sm: 'block' }}
            src="/logo-new.svg"
            style={{ objectFit: 'contain' }}
          />
          <Box
            component={'img'}
            width={'350px'}
            height={'200px'}
            display={{ xs: 'block', sm: 'none' }}
            src="/logo-new.svg"
            style={{ objectFit: 'contain' }}
          />
        </Box>
      </Box>
       */}
      <Box
        component={'div'}
        style={{ backgroundColor: '#f5f7f9' }}
        paddingBottom={{ xs: '40px', lg: '60px' }}
        paddingTop={{ xs: '40px', lg: '60px' }}
      >
        <Container maxWidth={'lg'}>
          <Typography
            fontFamily={'oswald'}
            textTransform={'uppercase'}
            fontWeight={700}
            className={classes.title}
          >
            Hacer periodismo{' '}
            <Box
              component={'br'}
              sx={{ display: { sm: 'block', md: 'none' } }}
            />{' '}
            <span>independiente y de calidad</span>
          </Typography>
          <Typography
            paddingTop={'12px'}
            fontFamily={'oswald'}
            fontWeight={'bold'}
            color={'#ff3c41'}
            textTransform={'uppercase'}
            className={classes.subTitle}
          >
            solo es posible con tu apoyo
          </Typography>
        </Container>
      </Box>
      {/**<Box component={'div'} style={{ backgroundColor: '#f3f4f6' }}>
        <PageAssociatedPlansEndless />
      </Box> */}
      <PlansSection />
      {/**<TipsSection /> */}
      {/**<PlansBenefits /> */}
      <StripeButtonWithoutStoreTipsBanner
        plan={{ stripe: { price_id: TIPS_PRICE_ID } }}
      />
      <ExtraBennefitsMobile />
      <ContactUsMobile />
      {/**
       * <NewsAttached />
       */}
      <div ref={ref}>{isVisible ? <ScrollDeph /> : null}</div>
    </div>
  );
};
